import Footer from '../Components/Footer/Footer'
import SpecialGridComponent from '../Components/Specials/SpecialGrid'


const SpecialGrid: React.FC = () => {
  

    return (
        <>

            <SpecialGridComponent />
            <Footer />
        </>
    )
}

export default SpecialGrid;